import { css } from '@compiled/react';
import { Options } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { useMemo } from 'react';

interface Asset {
  sys: {
    id: string;
  };
  url?: string;
  title?: string;
  description?: string;
  width?: number;
  height?: number;
}

interface RichTextLinks {
  assets?: {
    block?: (Asset | null)[];
  };
}

export const useRichTextEmbeddedAssets = (links?: RichTextLinks): Options => {
  return useMemo(() => {
    // Create a map of assets by ID for quick lookup
    const assetsMap = new Map<string, Asset>();

    links?.assets?.block?.forEach((asset) => {
      if (asset) {
        assetsMap.set(asset.sys.id, asset);
      }
    });

    const renderOptions: Options = {
      renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
          const assetId = node.data.target.sys.id;
          const asset = assetsMap.get(assetId);

          if (!asset?.url) {
            return null;
          }

          const imageUrl = asset.url.startsWith('//') ? `https:${asset.url}` : asset.url;
          const imageTitle = asset.title || asset.description || 'Embedded image';

          return (
            <img src={imageUrl} alt={imageTitle} width={asset.width} height={asset.height} css={embeddedImageStyles} />
          );
        },
      },
    };

    return renderOptions;
  }, [links]);
};

const embeddedImageStyles = css({
  maxWidth: '100%',
  height: 'auto',
  display: 'block',
  borderRadius: '8px',
  margin: '1.5rem 0',

  '&:first-child': {
    marginTop: 0,
  },

  '&:last-child': {
    marginBottom: 0,
  },
});
